import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Workspace } from '../../models/workspace/workspace';

@Component({
  selector: 'delete-workspace-modal',
  templateUrl: 'delete-workspace-modal.component.html',
  styleUrls: ['delete-workspace-modal.component.scss'],
  standalone: false
})
export class DeleteWorkspaceModalComponent {
  textMatcherValue: string = '';

  constructor(
    public dialogRef: MatDialogRef<DeleteWorkspaceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Workspace
  ) {}

  isDeleteButtonDisabled() {
    return this.textMatcherValue != 'DELETE';
  }

  deleteButtonClicked() {
    return true;
  }

  cancelButtonClicked() {
    return false;
  }
}
